(function () {
  var DATA_EL = document.getElementById("hhw-events-data");
  if (!DATA_EL) return;
  var DATA = JSON.parse(DATA_EL.textContent);
  var BRAND = DATA_EL.getAttribute("data-brand") || "#e84a8a";

  var MONTHS = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
  var MON_SHORT = ["Jan","Feb","Mae","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"];
  var DOW = ["Mo","Di","Mi","Do","Fr","Sa","So"];

  var today = new Date();
  var view = new Date(today.getFullYear(), today.getMonth(), 1); // aktueller Monat = synchron

  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function key(d) { return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()); }
  function evDate(e) { return e.start ? new Date(e.start) : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
  }); }
  function safeColor(c) { return /^#[0-9a-fA-F]{3,8}$/.test(c) ? c : BRAND; }

  // --- Hover-Schnellvorschau (Titel + Datum/Zeit + Ort) ---
  var TIP = document.createElement("div");
  TIP.className = "hhw-tip";
  document.body.appendChild(TIP);
  function fmtDateTime(iso) {
    var d = iso ? new Date(iso) : null;
    if (!d || isNaN(d)) return "";
    var s = d.getDate() + ". " + MONTHS[d.getMonth()] + " " + d.getFullYear();
    if (d.getHours() || d.getMinutes()) s += " · " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + " Uhr";
    return s;
  }
  function showTip(e, evt) {
    TIP.innerHTML =
      '<div class="hhw-tip__bar" style="background:' + safeColor(e.color) + '"></div>' +
      '<div class="hhw-tip__body">' +
        '<div class="hhw-tip__title">' + esc(e.title) + '</div>' +
        '<div class="hhw-tip__meta">' + esc(fmtDateTime(e.start)) + '</div>' +
        (e.location ? '<div class="hhw-tip__loc">📍 ' + esc(e.location) + '</div>' : '') +
      '</div>';
    TIP.classList.add("hhw-tip--on");
    moveTip(evt);
  }
  function moveTip(evt) {
    var off = 14, x = evt.clientX + off, y = evt.clientY + off;
    var w = TIP.offsetWidth, h = TIP.offsetHeight;
    if (x + w > window.innerWidth - 8) x = evt.clientX - w - off;
    if (y + h > window.innerHeight - 8) y = evt.clientY - h - off;
    TIP.style.left = Math.max(8, x) + "px";
    TIP.style.top = Math.max(8, y) + "px";
  }
  function hideTip() { TIP.classList.remove("hhw-tip--on"); }

  function render() {
    document.getElementById("hhw-month").textContent = MONTHS[view.getMonth()] + " " + view.getFullYear();

    var grid = document.getElementById("hhw-grid");
    grid.innerHTML = "";
    DOW.forEach(function (d) {
      var h = document.createElement("div");
      h.className = "hhw-cal__dow"; h.textContent = d; grid.appendChild(h);
    });

    var first = new Date(view.getFullYear(), view.getMonth(), 1);
    var startOffset = (first.getDay() + 6) % 7; // Mo=0
    var daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
    var todayKey = key(today);

    for (var i = 0; i < 42; i++) {
      var dayNum = i - startOffset + 1;
      if (dayNum < 1 || dayNum > daysInMonth) {
        var empty = document.createElement("div");
        empty.className = "hhw-cal__cell hhw-cal__cell--empty";
        grid.appendChild(empty);
        continue;
      }
      var cellDate = new Date(view.getFullYear(), view.getMonth(), dayNum);
      var ck = key(cellDate);
      var cell = document.createElement("div");
      cell.className = "hhw-cal__cell" + (ck === todayKey ? " hhw-cal__cell--today" : "");
      var num = document.createElement("span");
      num.className = "hhw-cal__num"; num.textContent = dayNum;
      cell.appendChild(num);

      var evWrap = document.createElement("div");
      evWrap.className = "hhw-cal__evs";
      var dayEvents = DATA.filter(function (e) { var d = evDate(e); return d && key(d) === ck; });
      var MAXROW = 3;
      dayEvents.slice(0, MAXROW).forEach(function (e) {
        // Echter Link, wenn Event-Seite existiert -> tastatur-/screenreader-tauglich.
        var chip = document.createElement(e.url ? "a" : "div");
        chip.className = "hhw-cal__ev";
        if (e.url) { chip.href = e.url; chip.setAttribute("aria-label", "Zum Event: " + e.title); }
        var cdot = document.createElement("span");
        cdot.className = "hhw-cal__evdot";
        cdot.style.background = safeColor(e.color);
        var ctitle = document.createElement("span");
        ctitle.className = "hhw-cal__evtitle";
        ctitle.textContent = e.title;   // textContent -> auto-escaped
        chip.appendChild(cdot);
        chip.appendChild(ctitle);
        (function (ev) {
          chip.addEventListener("mouseenter", function (m) { showTip(ev, m); });
          chip.addEventListener("mousemove", moveTip);
          chip.addEventListener("mouseleave", hideTip);
        })(e);
        evWrap.appendChild(chip);
      });
      if (dayEvents.length > MAXROW) {
        var more = document.createElement("div");
        more.className = "hhw-cal__evmore";
        more.textContent = "+" + (dayEvents.length - MAXROW) + " weitere";
        evWrap.appendChild(more);
      }
      cell.appendChild(evWrap);
      grid.appendChild(cell);
    }

    var ag = document.getElementById("hhw-agenda");
    ag.innerHTML = "";
    var monthEvents = DATA
      .filter(function (e) { var d = evDate(e); return d && d.getFullYear() === view.getFullYear() && d.getMonth() === view.getMonth(); })
      .sort(function (a, b) { return new Date(a.start) - new Date(b.start); });

    if (monthEvents.length === 0) {
      var emptyMsg = document.createElement("div");
      emptyMsg.className = "hhw-cal__empty";
      emptyMsg.textContent = "🐴 Keine Termine in diesem Monat.";
      ag.appendChild(emptyMsg);
      return;
    }
    monthEvents.forEach(function (e) {
      var d = evDate(e);
      var col = safeColor(e.color);
      // Echter Link, wenn eine Event-Seite existiert -> tastatur-/screenreader-
      // bedienbar (Tab + Enter), nicht nur Maus-Click auf ein <div> (A11y/EAA).
      var row = document.createElement(e.url ? "a" : "div");
      row.className = "hhw-ag";
      if (e.url) { row.href = e.url; row.setAttribute("aria-label", "Zum Event: " + e.title); }
      row.innerHTML =
        '<div class="hhw-ag__date"><div class="hhw-ag__day">' + d.getDate() + '</div>' +
        '<div class="hhw-ag__mon">' + MON_SHORT[d.getMonth()] + '</div></div>' +
        '<div class="hhw-ag__bar" style="background:' + col + '"></div>' +
        '<div class="hhw-ag__body">' +
          '<div class="hhw-ag__title">' + esc(e.title) + '</div>' +
          '<div class="hhw-ag__meta">' + d.getDate() + "." + (d.getMonth() + 1) + "." + d.getFullYear() +
            (d.getHours() || d.getMinutes() ? " · " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + " Uhr" : "") +
            (e.location ? " · " + esc(e.location) : "") + '</div>' +
        '</div>';
      ag.appendChild(row);
    });
  }

  document.getElementById("hhw-prev").addEventListener("click", function () {
    view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render();
  });
  document.getElementById("hhw-next").addEventListener("click", function () {
    view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render();
  });

  // --- Monats/Jahr-Picker (Klick auf Monats-Label) ---
  var picker = document.getElementById("hhw-picker");
  var yrLabel = document.getElementById("hhw-yr-label");
  var mGrid = document.getElementById("hhw-m-grid");
  var pSel = new Date(view.getFullYear(), view.getMonth(), 1);

  function renderPicker() {
    yrLabel.textContent = pSel.getFullYear();
    mGrid.innerHTML = "";
    MONTHS.forEach(function (name, i) {
      var b = document.createElement("button");
      b.className = "hhw-picker__m" + (i === view.getMonth() && pSel.getFullYear() === view.getFullYear() ? " hhw-picker__m--sel" : "");
      b.type = "button";
      b.textContent = name;
      b.addEventListener("click", function () {
        view = new Date(pSel.getFullYear(), i, 1);
        closePicker();
        render();
      });
      mGrid.appendChild(b);
    });
  }
  function openPicker() { renderPicker(); picker.classList.add("hhw-picker--open"); }
  function closePicker() { picker.classList.remove("hhw-picker--open"); }

  document.getElementById("hhw-month").addEventListener("click", openPicker);
  document.getElementById("hhw-yr-prev").addEventListener("click", function () {
    pSel = new Date(pSel.getFullYear() - 1, pSel.getMonth(), 1); renderPicker();
  });
  document.getElementById("hhw-yr-next").addEventListener("click", function () {
    pSel = new Date(pSel.getFullYear() + 1, pSel.getMonth(), 1); renderPicker();
  });
  picker.addEventListener("click", function (e) { if (e.target === picker) closePicker(); });

  render();
})();
